import React, { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import useModalHistory from '../hooks/useModalHistory';

export default function ConfirmModal({ message, onConfirm, onCancel, confirmLabel = 'Delete', danger = true }) {
  const { colors } = useTheme();

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onCancel]);

  useModalHistory(true, onCancel);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: colors.overlayBg }}
      role="dialog" aria-modal="true" aria-label="Confirm action">
      <div className="rounded-xl p-6 w-80 shadow-2xl flex flex-col gap-4"
        style={{ background: `linear-gradient(135deg, ${colors.accent}14 0%, ${colors.accent}04 100%)`, border: `1px solid ${colors.accent}30` }}>
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: danger ? '#f87171' : colors.accent }} />
          <p className="text-[14px] leading-snug" style={{ color: colors.primaryText }}>{message}</p>
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            aria-label="Cancel"
            className="px-3 py-1.5 rounded-lg text-[13px] font-medium"
            style={{ backgroundColor: colors.inputBg, color: colors.secondaryText }}>
            Cancel
          </button>
          <button
            onClick={onConfirm}
            aria-label={confirmLabel}
            className="px-3 py-1.5 rounded-lg text-[13px] font-medium text-white"
            style={{ backgroundColor: danger ? '#ef4444' : colors.accent }}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
